import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoYouTube = () => {
  return (
    <g>
      <path d="M15.665 3.876c-.184-.737-.722-1.314-1.414-1.515A44.68 44.68 0 0 0 8 2.004a44.68 44.68 0 0 0-6.25.358c-.692.2-1.231.778-1.415 1.515C.105 5.237-.008 6.617 0 8a23.834 23.834 0 0 0 .335 4.123c.184.738.723 1.315 1.414 1.515A44.68 44.68 0 0 0 8 13.996a44.68 44.68 0 0 0 6.25-.358c.693-.2 1.231-.778 1.415-1.515.23-1.36.343-2.74.335-4.123a23.834 23.834 0 0 0-.335-4.124zM6.42 10.518V5.482L10.581 8l-4.16 2.518z" />
    </g>
  );
};

export default withIcon(IconLogoYouTube);
